import { forwardRef } from "react";
import cn from "mcn";

export const LiveChartsIcon = forwardRef<
  SVGSVGElement,
  React.HTMLAttributes<SVGSVGElement> & {
    selected?: boolean;
    disableHover?: boolean;
    size?: string;
    inactive?: boolean;
    theme?: string;
    disabled?: boolean;
  }
>(function LiveChartsIcon({ selected, disableHover, size, inactive, theme, disabled, ...props }, ref) {
  const color = theme === "light" ? "#D0D1D4" : "#646464";
  const fill = inactive ? color : theme === "light" ? "#161616" : "#ffffff";
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: We have a custom tooltip
    <svg
      width={size ?? "42"}
      height={size ?? "42"}
      viewBox="0 -5 30 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={cn(
        selected ? "nav-icon selected group" : "nav-icon group",
        props.className,
        disabled ? "opacity-50" : "",
      )}
      ref={ref}
    >
      <path d="M5.5144 6.77588H3.5144V27.7759H5.5144V6.77588Z" fill={fill} />
      <path d="M15.3376 0.224365H13.3376V19.2244H15.3376V0.224365Z" fill={fill} />
      <path d="M25.3171 6.23706H23.3171V25.2371H25.3171V6.23706Z" fill={fill} />
      <path
        d="M8.5144 12.7759H0.514404V22.7759H8.5144V12.7759Z"
        style={disableHover ? { fill } : {}}
        className={`${disableHover ? "" : "fill-white group-hover:fill-chart-pos"}`}
      />
      <path
        d="M18.5144 3.77588H10.5144V12.7759H18.5144V3.77588Z"
        style={disableHover ? { fill } : {}}
        className={`${disableHover ? "" : "fill-white group-hover:fill-chart-pos"}`}
      />
      <path
        d="M28.4856 12.5544H20.4856V20.5544H28.4856V12.5544Z"
        style={disableHover ? { fill } : {}}
        className={`${disableHover ? "" : "fill-white group-hover:fill-chart-neg"}`}
      />
    </svg>
  );
});
